import { Global, css } from '@emotion/react';
import * as React from 'react';
import Head from 'next/head';
import { useObservability } from '../../helpers/observability';

import { Box, Text } from '@opendoor/bricks/core';
import { UNSAFE_CtaButton } from '@opendoor/bricks/deprecated/UNSAFE_CtaButton';
import odometerCSS from '../shared/odometerCSS';
import useOdometer from '../shared/useOdometer';

declare global {
  interface Window {
    odometerOptions: any;
    Odometer: any;
  }
}

const assetPrefix = 'https://cdn-cosmos.opendoor.com/js';

const SocialProofOdometer = () => {
  const odometerStart = 388456;
  const [inViewRef, inView, odometerRef] = useOdometer(odometerStart);
  const { trackEvent } = useObservability();

  const onClickFn = () => {
    // TODO: remove categoryOverride
    // observability is initialized with 'cosmos' as the category for all events
    trackEvent('cta-click', 'social-proof-odometer-get-started', undefined, {
      categoryOverride: 'homepage',
    });
    window.location.assign('/address-entry');
  };

  return (
    <React.Fragment>
      <Head>
        <script async src={`${assetPrefix}/odometer.min.js`} />
      </Head>
      <Global styles={css(odometerCSS)} />
      <Box
        as="section"
        id="social-proof-odometer-container"
        ref={inViewRef}
        mt={[11]}
        py={10}
        backgroundColor="blue30"
      >
        <Box
          width={['85%', null, 'initial', 'initial']}
          mx="auto"
          lineHeight={1}
          textAlign="center"
        >
          {inView && (
            <Box
              // @ts-expect-error TODO - @growth to resolve
              fontSize={['42px', null, '120px', '120px']}
              fontWeight="bold"
              color="brand50"
              lineHeight={1}
            >
              <Box ref={odometerRef} id="odometer" display="inline-block">
                {odometerStart}
              </Box>
              +
            </Box>
          )}
          <Text fontSize="s00" fontWeight="semibold" color="brand50" mb="3">
            OFFERS REQUESTED
          </Text>
          <Text mt={[3, 0]} color="neutrals100">
            Every 60 seconds, a homeowner requests an offer from Opendoor
          </Text>
          <Box width={['70%', null, '300px', '300px']} mx="auto" mt={[7, null, null, 8]}>
            <UNSAFE_CtaButton
              aria-label=""
              analyticsName="cosmos-homepage-socialProofOdometer-get-free-offer"
              actionText="Get my free offer"
              designStyle="rounded"
              size="large"
              onClick={onClickFn}
            />
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default SocialProofOdometer;
